import { render, staticRenderFns } from "./Expohallbird.vue?vue&type=template&id=c818a446&scoped=true"
import script from "./Expohallbird.vue?vue&type=script&lang=js"
export * from "./Expohallbird.vue?vue&type=script&lang=js"
import style0 from "./Expohallbird.vue?vue&type=style&index=0&id=c818a446&prod&scope=true&lang=css"
import style1 from "./Expohallbird.vue?vue&type=style&index=1&id=c818a446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c818a446",
  null
  
)

export default component.exports